import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mobile-header"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'mobileHeader',
  emits: ['gotoCompressImg'],
  setup(__props, {
    emit: $emit
  }) {
    const router = useRouter();
    let drawer = ref(false);
    function gotoCompressImg() {
      $emit('gotoCompressImg');
    }
    function gotoCreateImg() {
      router.push('/createImg');
    }
    function gotoCropImg() {
      router.push('/cropImg');
    }
    function gotoQrcode() {
      router.push('/qrCode');
    }
    return (_ctx, _cache) => {
      const _component_Expand = _resolveComponent("Expand");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Fold = _resolveComponent("Fold");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => _isRef(drawer) ? drawer.value = !_unref(drawer) : drawer = !_unref(drawer)),
        class: "header"
      }, [!_unref(drawer) ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_Expand)]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_icon, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_Fold)]),
        _: 1
      }))]), _createElementVNode("div", null, [_createVNode(_component_a_drawer, {
        placement: "left",
        width: "200",
        open: _unref(drawer),
        "onUpdate:open": _cache[3] || (_cache[3] = $event => _isRef(drawer) ? drawer.value = $event : drawer = $event),
        title: "菜单"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          style: {
            "margin-bottom": "20px"
          }
        }, [_createElementVNode("span", {
          onClick: gotoCreateImg,
          style: {
            "margin-right": "20px"
          }
        }, "图片生成")]), _createElementVNode("div", {
          style: {
            "margin-bottom": "20px"
          }
        }, [_createElementVNode("span", {
          onClick: gotoCropImg
        }, "图片裁剪")]), _createElementVNode("div", {
          onClick: gotoQrcode,
          style: {
            "margin-bottom": "20px"
          }
        }, "生成二维码"), _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = $event => _ctx.gotoCourse('js')),
          style: {
            "margin-bottom": "20px"
          }
        }, "图片转换"), _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = $event => _ctx.gotoCourse('js')),
          style: {
            "margin-bottom": "20px"
          }
        }, "图片转base64"), _createElementVNode("div", {
          onClick: gotoCompressImg,
          style: {
            "margin-bottom": "20px"
          }
        }, "图片压缩")]),
        _: 1
      }, 8, ["open"])])]);
    };
  }
};